import LangEnum from '../../../lang/LangEnum';
import AutoContractGeneration from '../enums/autoContractGeneration.enum';

export const getAutoContractGenerationLangEnum = (value: AutoContractGeneration): LangEnum => {
  const mappedLangEnum: {
    [key in AutoContractGeneration]: LangEnum;
  } = {
    [AutoContractGeneration.IN_REVISION_OR_ON_APPROVAL]:
      LangEnum.AUTO_CONTRACT_GENERATION_IN_REVISION_OR_ON_APPROVAL,
    [AutoContractGeneration.ON_APPROVAL]: LangEnum.AUTO_CONTRACT_GENERATION_ON_APPROVAL,
    [AutoContractGeneration.ON_APPROVED]: LangEnum.AUTO_CONTRACT_GENERATION_ON_APPROVED,
  };
  return mappedLangEnum[value];
};
